import { Country } from './index';

export class CountryResponse {
  allCountriesList: Country[];
  countriesListLoading: boolean;
  loading: boolean;
  countryList: Country[];
}
